//import store_lang from '@/i18n';
//import Vue from 'vue'
const Menu =  [
  { header: 'Apps' },
  { divider: true },
  {
    title: 'Membres',
    group: 'widgets',
    component: 'widgets',
    icon: 'widgets',
    dispatch:'fetchMembers',
    items: [ 
      { name: 'chart', title: 'Servants', component: 'components/widget-serviteurs' , dispatch:'fetchMembers' },
      { name: 'chart', title: 'Massaga', component: 'components/widget-massaga' , dispatch:'fetchMembers' }
    ]
  },

  { divider: true },
  { header: 'Community' },
  {
    title: 'Projets',
    group: 'apps',
    icon: 'build',
    name: 'widget-projects',
    dispatch:'fetchProjects'
  },
  {
    title: 'Chat',
    group: 'apps',
    icon: 'chat_bubble',
    name: 'widget-chat',
    dispatch:'fetchConvos'
  },
  {
    title: 'Medias',
    group: 'apps',
    icon: 'video_library',
    name: 'widget-medias',
    dispatch:'fetchMedias'
  },
  {
    title: 'Events',
    group: 'apps',
    icon: 'event',
    name: 'widget-events',
    dispatch:'fetchEvents'
  },
  {
    title: 'Postes',
    group: 'apps',
    icon: 'format_paint',
    name: 'widget-post',
    dispatch:'fetchJobs'
  },
  {
    title: 'Prayers',
    group: 'apps',
    icon: 'format_paint',
    name: 'widget-prayers',
    dispatch:'fetchPrayers'
  },

];
const CMenu =  [
];

// reorder menu
Menu.forEach((item) => {
  if (item.items) {
    item.items.sort((x, y) => {
      let textA = x.title.toUpperCase();
      let textB = y.title.toUpperCase();
      return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
    });
  }
});

export default Menu;



// WEBPACK FOOTER //
// ./src/api/menu_serviteur.js